import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Proj1 from "../../Assets/proj1.png";
import Proj2 from "../../Assets/webScraperLogo.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Proj1}
              isBlog={false}
              title="Blue Horizon Exteriors"
              description="Professional Website for Roofing Company"
              ghLink="https://github.com/operator-axel/tiger/"
              demoLink="https://www.bluehorizonexteriors.com"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Proj2}
              isBlog={false}
              title="Go Web Scraper that takes user input"
              description="Super fast Web Scraper built in Go - Parses links into Markdown links and creates a new note in Obsidian Vault"
              ghLink="https://github.com/operator-axel/web-scraper-go/"
              demoLink=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
